import { Navigate, useParams } from 'react-router-dom';

/** Alter Pfad /admin/objekte/:id/einheit/:einheitId → /admin/objekte/:id/einheiten/:einheitId (README §10). */
export default function AlteEinheitWeiterleitung() {
  const { id, einheitId } = useParams<{ id: string; einheitId: string }>();
  if (!id) return <Navigate to="/admin/objekte" replace />;
  const ziel = einheitId
    ? `/admin/objekte/${encodeURIComponent(id)}/einheiten/${encodeURIComponent(einheitId)}`
    : `/admin/objekte/${encodeURIComponent(id)}`;
  return <Navigate to={ziel} replace />;
}
